import { render } from "./RegistrationQuoteAmountBlockComponent.vue?vue&type=template&id=77663094&scoped=true"
import script from "./RegistrationQuoteAmountBlockComponent.vue?vue&type=script&lang=js"
export * from "./RegistrationQuoteAmountBlockComponent.vue?vue&type=script&lang=js"

import "./RegistrationQuoteAmountBlockComponent.vue?vue&type=style&index=0&id=77663094&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77663094"]])

export default __exports__